<ng-container *ngIf="schemaInfo">


    <!-- Kanäle nach LED Prüfen -->
    <div class="d-flex justify-content-between">
        <h6 class="fw-semibold text-secondary">Helligkeitseinstellungen</h6>
        <span *ngIf="!online" class="text-danger ms-2"> Gerät offline</span>
        <span *ngIf="selectKanalInput.length < 1" class="text-danger ms-2">Keine Kanäle gefunden!</span>
        <span class="text-danger ms-2" *ngIf="!brightnessClusterChannelExists"> Cluster-Kanal für
            Helligkeitseinstellungen
            fehlt</span>
        <div class="d-flex" style="gap: 18px">

            <mat-form-field>
                <mat-label>Modus</mat-label>
                <mat-select [(ngModel)]="ledMode" (selectionChange)="onSelectOption($event.value)">
                    <mat-option [value]="0">Automatischer Modus</mat-option>
                    <mat-option [value]="1">Manueller Modus</mat-option>
                    <!-- [disabled]="isChainZone" --><mat-option [value]="2" >Verlinkter Modus</mat-option> 
                    <mat-option [value]="3" disabled>Unbekannt</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <div class="row align-items-center mb-3 mt-4">
        <div class="col-md-5 d-flex mb-2 flex-column">
            <p class="mb-1" [ngClass]="selectKanalInput.length < 1 ? 'text-secondary' : ''">Helligkeit:</p>
            <avs-text-input type="number" class="avs-test-area-input mx-3" [value]="brightness"
                [disabled]="ledMode === 0 || ledMode === 2 || ledMode === 3 || !online || selectKanalInput.length < 1"
                (valueChange)=onBrightnessInputValueChange(+$event)></avs-text-input>
        </div>
        <div class="col-md-7">
            <input type="range" [(ngModel)]="brightness"
                (ngModelChange)="onBrightnessInputValueChange($event)" min="0" max="100"
                [disabled]="ledMode === 0 || ledMode === 2 || ledMode === 3 || !online || selectKanalInput.length < 1"
                class="form-range w-100 p-3">
        </div>
    </div>

    <div class="row align-items-center mb-3 mt-4">
        <div class="col-md-5 d-flex mb-2 flex-column">
            <p class="mb-1" [ngClass]="selectKanalInput.length < 1 ? 'text-secondary' : ''">Max Helligkeit:</p>
            <avs-text-input type="number" class="avs-test-area-input mx-3" [value]="maxBrightness"
                [disabled]="ledMode === 1 || ledMode === 3 || !online || selectKanalInput.length < 1"
                (valueChange)=onMaxBrightnessInputValueChange(+$event)></avs-text-input>
        </div>
        <div class="col-md-7">
            <input type="range" [(ngModel)]="maxBrightness"
                (ngModelChange)="onMaxBrightnessInputValueChange($event)" min="0" max="100"
                [disabled]="ledMode === 1 || ledMode === 3 || !online || selectKanalInput.length < 1"
                class="form-range w-100 p-3">
        </div>
    </div>

    <div class="d-flex align-items-start">
        <div class="row w-100">
            <div class="col-md-6 d-flex justify-content-start ms-1">
                <mat-slide-toggle color="primary" [checked]="spontaneousMessages"
                    [disabled]="!online || selectKanalInput.length < 1"
                    (change)="onSpontaneousReportChanged($event.checked)">
                    Spontane Meldung
                </mat-slide-toggle>
            </div>
        </div>
    </div>

    <div class="text-end" *ngIf="isAnyValueChanged">
        <button class="btn btn-outline-danger rounded-0 mt-5 ms-2" type="button"
            (click)="onSaveBtnClicked()">Speichern</button>
    </div>
</ng-container>
<div *ngIf="!schemaInfo">
    <p class="text-secondary">Keine Helligkeitseinstellungen verfügbar.</p>
</div>